<script lang="ts">
	import { onMount } from "svelte"
	import { Paragraph } from "misc-ui"
	let inputValue: string = $state()
	let inputElem: HTMLInputElement = $state()

	interface Props {
		label?: string
		prompt?: string | Array<string>
		buttonText?: string
		defaultValue?: string
		onSubmit?: (input: string) => void
		closeOverlay: () => void
	}

	let {
		label = undefined,
		prompt = undefined,
		buttonText = undefined,
		defaultValue = undefined,
		onSubmit = undefined,
		closeOverlay,
	}: Props = $props()

	onMount(() => {
		inputValue = defaultValue
		inputElem.focus()
	})
</script>

<form
	onsubmit={(e) => {
		e.preventDefault()
		onSubmit(inputValue)
		closeOverlay()
	}}
>
	{#if prompt}
		<Paragraph textContent={prompt} />
	{/if}
	<div class="input-container">
		{#if label}
			<label for="overlay-text-input">{label}</label>
		{/if}
		<input
			id="overlay-text-input"
			type="text"
			bind:value={inputValue}
			bind:this={inputElem}
		/>
	</div>
	<button type="submit">{buttonText || "Submit"}</button>
</form>

<style>
	form {
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-evenly;
	}
</style>
